import React, {PureComponent} from "react"
import styled from "styled-components"

import {H3} from "@irati/ui/src//Typography/Heading"
import {injectIntl, InjectIntl} from "@irati/utils/lang"
import {formatCurrency} from "@irati/utils/currency/formatCurrency"
import Button from "@irati/ui/src/Button"
import Modal from "@irati/ui/src/Modal"
import {ModalHeader} from "@irati-web/recognition/src/components/Popup/shared/Modal"
import firstnameLastname from "@irati/identity/helpers/user/firstnameLastname"
import {User} from "@irati/types"

const StyledH3 = styled(H3)`
  text-align: center;
`

interface Props extends InjectIntl {
  recipient: User,
  value?: number,
  onClose: () => void
}

class SendCreditsuccessModal extends PureComponent<Props> {
  render() {
    const {recipient, value, formatMessage, onClose} = this.props

    return (
      <Modal show onHide={onClose} onExited={onClose} renderHeader={({size}) => <ModalHeader users={[recipient]} size={size} />}>
        <StyledH3 small>
          {formatMessage(
            {id: "wallet.sendCredit.successModal.text"},
            {value: formatCurrency({value}), recipient: firstnameLastname(recipient)}
          )}
        </StyledH3>
        <Button large full primary onClick={onClose}>
          {formatMessage({id: "wallet.sendCredit.successModal.button"})}
        </Button>
      </Modal>
    )
  }
}

export default injectIntl(SendCreditsuccessModal)
